import type { VBaseButtonProps } from './type';

export const VBaseButton = ({
  children,
  ref,

  loading,
  outlined,
  variant,
  ...rest
}: React.PropsWithChildren<
  VBaseButtonProps & React.ComponentPropsWithRef<'button'>
>) => {
  return (
    <button
      ref={ref}
      aria-busy={loading}
      data-outlined={outlined}
      data-variant={variant}
      {...rest}
    >
      {children}
    </button>
  );
};

VBaseButton.displayName = 'VBaseButton';
